import { IFacility } from '~/utils/interface/facility';
import axiosClient from './axiosClient';
import { IGetAllResponse } from '~/utils/interface/facility';

const url = 'api/installation-location';

const facilityApi = {
  getListFacility(data: IFacility) {
    return axiosClient.post<IGetAllResponse>(`${url}/find`, data);
  },

  getDetailFacility(id: number) {
    return axiosClient.get<IFacility>(`${url}/${id}`);
  },

  getListAlert(id: number) {
    return axiosClient.get<IFacility>(`${url}/list-alert/${id}`);
  },

  getListReports(id: number) {
    return axiosClient.get<any>(`${url}/list-check-reports/${id}`);
  },

  updateCheckCycle(data: any) {
    return axiosClient.post<any>(`${url}/update-check-cycle`, data);
  },

  deleteDevice(data: any) {
    return axiosClient.delete<any>(`/api/device/delete`, { data });
  },

  addCheckReport(data: any) {
    return axiosClient.post<any>(`${url}/add-check-report`, data);
  },

  updateCheckReport(data: any, id: string) {
    return axiosClient.put<any>(`${url}/update-check-report/${id}`, data);
  },

  getListFacilityByUser(username: string) {
    return axiosClient.get<IFacility[]>(`${url}/list-locations-by-user/${username}`);
  },

  create(data: any, username: string) {
    return axiosClient.post<any>(`${url}/admin/create?username=${username}`, data);
  },

  update(data: any, username: string) {
    return axiosClient.post<any>(`${url}/admin/update?username=${username}`, data);
  },

  delete(data: any) {
    return axiosClient.delete<any>(`${url}/admin/delete`, { data });
  },
};

export default facilityApi;
